module.exports = __webpack_public_path__ + "static/media/dead_disconnected_bat.2ab8c481.svg";